import * as React from "react";

export const IconMinus = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="11" width="16" height="2" rx="1" fill="currentColor" />
  </svg>
);
